/* =========================================================================
   AF split test — PDP Add-to-cart button color.

   Arm A is the shipping black button; arm B is brand terracotta #8F5642.
   Nothing about the offer, price, copy or position changes between them, so
   any difference in the numbers is the color and only the color.

   THE BUCKET IS ASSIGNED ELSEWHERE. A tiny inline script in
   sections/af-main-product.liquid runs before the button paints and puts
   `af-atc-b` on <html> for arm B — that has to happen before first paint or
   half the shoppers watch the button change color under them, which is both
   ugly and its own confound. This file only reads the decision back and
   reports what happened.

   Assignment is per BROWSER, not per pageview: a shopper who compares two
   frames must see one color, not a flicker. The coin is tossed once and kept
   in localStorage.

   What gets reported, all through the existing AFUpsell pipe
   (af-upsell-collect.js, App Proxy, first-party — ad blockers don't touch it):

     impression  the button actually entered the viewport. Not "the page
                 loaded": a button nobody scrolled to cannot have been judged
                 on its color, and counting it would dilute both arms.
     click       the shopper pressed it. Once per pageview, so the rate stays
                 a readable 0-100% instead of being inflated by double-clicks.
     add         the add succeeded, carrying the cart token. This is the row
                 that lets a paid order be tied back to the arm later.

   Every step is wrapped: a split test must never be the reason a shopper
   cannot add to cart.
   ========================================================================= */
(function () {
  'use strict';

  var STORAGE_KEY = 'af_ab_atc';
  var PLACEMENT = 'pdp_atc';
  /* The values that land in UpsellEvent.abVariant. The analytics app maps
     these to row labels — change one here and change it there too. */
  var ARM = { a: 'atc_black', b: 'atc_terracotta' };

  function arm() {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'b' ? ARM.b : ARM.a;
    } catch (e) {
      /* Private mode: the inline script could not persist a bucket either, so
         it left the shopper on the default black. Report the same. */
      return ARM.a;
    }
  }

  function track(eventType, extra) {
    try {
      if (!window.AFUpsell || typeof window.AFUpsell.track !== 'function') return;
      var payload = { placement: PLACEMENT, abVariant: arm() };
      for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) payload[k] = extra[k];
      window.AFUpsell.track(eventType, payload);
    } catch (e) { /* analytics must never break the store */ }
  }

  /* The product this button belongs to, so a color that works on frames but
     not on blankets is visible rather than averaged away. */
  function productContext(root) {
    var out = {};
    try {
      var form = root && root.closest ? root.closest('form') : null;
      var vid = form && form.querySelector('[name="id"]');
      if (vid && vid.value) out.variantId = vid.value;
      var section = document.querySelector('[data-af-product-json]');
      if (section) {
        var p = JSON.parse(section.textContent || '{}');
        if (p.handle) out.handle = p.handle;
        if (p.title) out.title = p.title;
      }
    } catch (e) { /* context is a nicety, never a requirement */ }
    return out;
  }

  function start() {
    var btn = document.querySelector('[data-af-atc]');
    if (!btn) return; // not a product page with our buy box
    var ctx = productContext(btn);

    /* ---- impression: first time the button is genuinely on screen -------- */
    var seen = false;
    function markSeen() {
      if (seen) return;
      seen = true;
      track('impression', ctx);
    }
    try {
      if (typeof IntersectionObserver === 'function') {
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) { markSeen(); io.disconnect(); return; }
          }
        }, { threshold: 0.5 });
        io.observe(btn);
      } else {
        markSeen(); // no IO (old Safari): count the pageview rather than nothing
      }
    } catch (e) {
      markSeen();
    }

    /* ---- click, then the add that followed ------------------------------ */
    var clicked = false;
    function onClick() {
      /* A button that is clicked without ever having been observed (keyboard
         straight to it, or IO starved on a background tab) still counts as
         shown — otherwise the rate can exceed 100%. */
      markSeen();
      if (clicked) return;
      clicked = true;
      track('click', ctx);

      /* The cart token only exists once something is in the cart, so it has
         to be read AFTER the add resolves. Without it a paid order cannot be
         tied back to this arm and the CVR column stays empty. */
      setTimeout(function () {
        try {
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              if (!cart || !cart.token) return;
              if (window.AFUpsell && window.AFUpsell.setCartContext) {
                window.AFUpsell.setCartContext(cart);
              }
              track('add', ctx);
            })
            .catch(function () {});
        } catch (e) { /* ignore */ }
      }, 900);
    }

    btn.addEventListener('click', onClick);
    /* The mobile sticky bar submits the same form, so it is the same button
       as far as the shopper is concerned — and it is the same color. */
    var sticky = document.querySelector('[data-af-sticky-add]');
    if (sticky) sticky.addEventListener('click', onClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
